import React, { useState, useEffect, useCallback, useContext, useRef } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button, Form, ButtonGroup } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
// import { reactLocalStorage } from 'reactjs-localstorage';
import { Col, Row, Container } from 'react-bootstrap'
import { formatDate } from '../utils/functions';


const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const AddPresciption = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const [startDate, setStartDate] = useState(new Date());
    var location = useLocation();

    const { state } = useContext(Context)

    const [selectedDate, setSelectedDate] = useState()
    const [loading, setLoading] = useState(false)
    const [storeCustomers, setStoreCustomers] = useState(state.customers ? state.customers : [])

    const [pData, setPData] = useState({
        patient_id: location?.state?.cust_id ? location.state.cust_id : location?.state?.id ? location.state.id : '',
        st_id: state.storeData.st_id,
        prescriber: location?.state?.prescriber ? location.state.prescriber : '',
        prescription_date: location?.state?.prescription_date ? location.state.prescription_date : '',
        h_phone: location?.state?.h_phone ? location.state.h_phone : '',
        o_phone: location?.state?.o_phone ? location.state.o_phone : location?.state?.cust_phone ? location.state.cust_phone : '',
        odsph: location?.state?.odsph ? location.state.odsph : '',
        odcyl: location?.state?.odcyl ? location.state.odcyl : '',
        odaxis: location?.state?.odaxis ? location.state.odaxis : '',
        odprism: location?.state?.odprism ? location.state.odprism : '',
        odfi: location?.state?.odfi ? location.state.odfi : '',
        odct: location?.state?.odct ? location.state.odct : '',
        ossph: location?.state?.ossph ? location.state.ossph : '',
        oscyl: location?.state?.oscyl ? location.state.oscyl : '',
        osaxis: location?.state?.osaxis ? location.state.osaxis : '',
        osprism: location?.state?.osprism ? location.state.osprism : '',
        osfi: location?.state?.osfi ? location.state.osfi : '',
        osct: location?.state?.osct ? location.state.osct : '',
        spect: location?.state?.spect ? location.state.spect : '0',
        dist: location?.state?.dist ? location.state.dist : '0',
        near: location?.state?.near ? location.state.near : '0',
        sv: location?.state?.sv ? location.state.sv : '0',
        protective_eyewear: location?.state?.protective_eyewear ? location.state.protective_eyewear : '0',
        contact_lenses_rx: location?.state?.contact_lenses_rx ? location.state.contact_lenses_rx : '0',
        bifocals: location?.state?.bifocals ? location.state.bifocals : '0',
        transitions: location?.state?.transitions ? location.state.transitions : '0',
        progressive: location?.state?.progressive ? location.state.progressive : '0',


    })
    const [customer, setCustomer] = useState();

    const [value, setValue] = useState(location?.state ? location.state.cust_fname + " " + location.state.cust_lname : "");
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);
    const [suggestionArr, setSuggestionArr] = useState([])



    // function formatDate(dateObj) {

    //     if (dateObj.getMonth() < 10) {
    //         const month = "0" + dateObj.getMonth();
    //         if (dateObj.getDate() < 10) {
    //             const dat = "0" + dateObj.getDate();
    //             let date = dateObj.getFullYear() + "-" + month + "-" + dat;
    //             return date
    //             // props.onValueChange(date);
    //         }
    //         else {
    //             let date = dateObj.getFullYear() + "-" + month + "-" + dateObj.getDate()
    //             return date
    //             // props.onValueChange(date);
    //         }
    //     }
    //     else {
    //         if (dateObj.getDate() < 10) {
    //             const dat = "0" + dateObj.getDate()
    //             let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dat
    //             return date
    //             // props.onValueChange(date);
    //         }
    //         else {
    //             let date = dateObj.getFullYear() + "-" + dateObj.getMonth() + "-" + dateObj.getDate()
    //             return date
    //             // props.onValueChange(date);
    //         }

    //     }
    // }

    function findCustName(v) {
        var filter = storeCustomers.filter(e => e.cust_id == v)
        console.log('filter is')
        console.log(filter)
        return filter[0].cust_fname + " " + filter[0].cust_lname
    }

    function addPresc(event) {

        event.preventDefault();
        if (pData.patient_id == '') {
            alert('Please select customer')
            return
        }
        if (pData.prescriber == '') {
            alert('Please enter a valid prescriber')
            return
        }
        if (pData.prescription_date == '') {
            alert('Prescription date is missing')
            return
        }
        if (pData.h_phone == '' && pData.o_phone == '') {
            alert('Please enter at least one phone')
            return
        }
        if (pData.odsph == '') {
            alert('odsph is missing')
            return
        }
        if (pData.odcyl == '') {
            alert('odcyl is missing')
            return
        }
        if (pData.odaxis == '') {
            alert('odaxis is missing')
            return
        }
        if (pData.odprism == '') {
            alert('odprism is missing')
            return
        }
        if (pData.odfi == '') {
            alert('odfi is missing')
            return
        }
        if (pData.odct == '') {
            alert('odct is missing')
            return
        }
        if (pData.ossph == '') {
            alert('ossph is missing')
            return
        }
        if (pData.oscyl == '') {
            alert('oscyl is missing')
            return
        }
        if (pData.osaxis == '') {
            alert('osaxis is missing')
            return
        }
        if (pData.osprism == '') {
            alert('osprism is missing')
            return
        }
        if (pData.osfi == '') {
            alert('osfi is missing')
            return
        }
        if (pData.osct == '') {
            alert('osct is missing')
            return
        }

        setLoading(true)
        console.log('pData is')
        console.log(pData)
        apiRequest(pData, 'addpresc')
            .then(data => {
                setLoading(false)
                console.log(data)
                // console.log(data)
                if (data.status == 1) {
                    // alert('Prescription added')
                    history.replace('/managePrescription',
                        pData.patient_id,
                    )
                }
                else {
                    console.log(data.error)
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                // console.log(err)
                alert('Internet Error')
            })



    }

    function getStoreCustomers() {
        setLoading(true)
        apiRequest({ st_id: state.storeData.st_id }, 'viewcustomers')
            .then(data => {
                setLoading(false)
                if (data.status == '1') {
                    setStoreCustomers(data.data)
                }
                else {
                    alert(data.error)
                }

                console.log(data)
            })
    }



    useEffect(() => {
        console.log('location')
        console.log(location)
        if (!state.customers.length) {
            getStoreCustomers()
            // setStoreCustomers
        }


    }, [])



    // const PrescriptionView = () => (

    // )

    return (
        <div
            onClick={() => setSuggestionArr([])}
            id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >
                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">Add Prescription</h1>
                                            </div>

                                            <div className="row">




                                                <form onSubmit={(e) => addPresc(e)} style={{ marginTop: 20 }} >
                                                    <div className="editDetails" >Customer</div>
                                                    {/* <select
                                                        required={true}
                                                        className="col-sm-6 mb-3 mb-sm-0 form-control form-control-user" size="md"
                                                        onChange={(v) => {
                                                            let obj = v.target.value
                                                            obj = JSON.parse(obj)
                                                            console.log(obj)
                                                            setPData({
                                                                ...pData,
                                                                patient_id: obj.cust_id,
                                                                o_phone: obj.cust_phone == null ? '' : obj.cust_phone,
                                                                h_phone: obj.h_phone == null ? '' : obj.h_phone

                                                            })
                                                            forceUpdate();
                                                        }}
                                                    >
                                                        {
                                                            storeCustomers?.map((v, i) => {
                                                                return (
                                                                    <>
                                                                        {
                                                                            i == 0 &&
                                                                            <option disabled={true} selected={location?.state?.cust_id || location?.state?.id ? false : true}>Select</option>
                                                                        }
                                                                        
                                                                        <option selected={location?.state?.cust_id == v.cust_id || location?.state?.id == v.cust_id ? true : false} value={JSON.stringify(v)}>{v.cust_fname} {v.cust_lname}</option>
                                                                        
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                    </select> */}
                                                    <div className="input__wrapper" ref={wrapperRef}>

                                                        <input
                                                            type="text"
                                                            style={{ fontFamily: 'PRe' }}
                                                            placeholder={value ? value : "Search Customer"}
                                                            className="form-control form-control-user"
                                                            onChange={(v) => {

                                                                var val = v.target.value
                                                                setValue(val)
                                                                console.log('val =' + val)
                                                                if (!val.length) {
                                                                    setSuggestionArr([])
                                                                    // setOrders(orderArr)
                                                                    return
                                                                }
                                                                try {
                                                                    var search = new RegExp(val, 'i'); // prepare a regex object
                                                                }
                                                                catch (err) {
                                                                    console.log(err)
                                                                }
                                                                var c = [];
                                                                var i = 0;
                                                                for (let key in storeCustomers) {
                                                                    if (val.indexOf(' ') >= 0) {
                                                                        try {
                                                                            if (search.test(storeCustomers[key].cust_fname + " " + storeCustomers[key].cust_lname)) {
                                                                                c[i] = storeCustomers[i]
                                                                            }
                                                                        }
                                                                        catch (err) { }

                                                                    }
                                                                    try {
                                                                        if (search.test(storeCustomers[key].cust_fname) || search.test(storeCustomers[key].cust_lname) || search.test(storeCustomers[key].cust_phone)) {
                                                                            c[i] = storeCustomers[i]
                                                                        }
                                                                    }
                                                                    catch (err) { }

                                                                    i++;
                                                                }
                                                                setSuggestionArr(c)
                                                                forceUpdate()
                                                            }}
                                                            onFocus={() => {
                                                                setShowDropdown(true)
                                                                setSuggestionArr(storeCustomers)
                                                            }}
                                                            // onBlur = {()=>{setSuggestionArr([])}}
                                                            value={value}
                                                        />
                                                        {/* {showDropdown && ( */}
                                                        <div className="suggestions__dropdown" >
                                                            {suggestionArr?.length > 0 ? (
                                                                <div style={{ position: 'fixed', zIndex: 1000, backgroundColor: 'rgba(128,128,128,1)', width: "50%", borderRadius: 5, padding: 10 }}>
                                                                    {suggestionArr.map((v, index) => {
                                                                        return (
                                                                            <div style={{ marginTop: 0 }}>
                                                                                <input
                                                                                    type="button"
                                                                                    style={{ width: "100%", textAlign: 'left', backgroundColor: 'rgba(128,128,128,1)', color: 'white', borderWidth: 0, fontFamily: 'PMe', fontSize: 14 }}

                                                                                    value={v.cust_id}
                                                                                    onClickCapture={() => {
                                                                                        // alert('asd')
                                                                                        // var c = orderArr.filter(item => item.cust_id == v.cust_id)
                                                                                        // setOrders(c)
                                                                                        setPData({
                                                                                            ...pData,
                                                                                            patient_id: v.cust_id,
                                                                                            o_phone: v.cust_phone == null ? '' : v.cust_phone,
                                                                                            h_phone: v.h_phone == null ? '' : v.h_phone

                                                                                        })
                                                                                        setSuggestionArr([])
                                                                                        setValue(v.cust_fname + " " + v.cust_lname)
                                                                                        forceUpdate()
                                                                                    }}
                                                                                    key={"suggestion_" + index}
                                                                                    // placeholder={v.cust_fname.toString()}
                                                                                    value={v.cust_fname.toString() + " " + v.cust_lname + " - " + v.cust_phone}

                                                                                // onClick={() => setValue(v)}
                                                                                />
                                                                            </div>

                                                                        )
                                                                    })}
                                                                </div >
                                                            ) : (
                                                                null
                                                                // <div className="no__suggestions">No suggestions found</div>
                                                            )}
                                                        </div>
                                                        {/* )} */}
                                                    </div>

                                                    <div class="row mt-2 mb-3 ">
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >H-Phone</div>
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-user"
                                                                
                                                                // disabled={true}
                                                                value={pData.h_phone}
                                                                placeholder={pData.h_phone}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        h_phone: v.target.value
                                                                    })
                                                                }}

                                                            />
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >C-Phone</div>
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-user"
                                                                
                                                                // disabled={true}
                                                                value={pData.o_phone}
                                                                placeholder={pData.o_phone}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        o_phone: v.target.value
                                                                    })
                                                                }}
                                                            // placeholder="O-Phone" 
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2 mb-3 ">
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >Prescriber</div>
                                                            <input
                                                                className="form-control form-control-user"
                                                                required
                                                                // type="email"
                                                                value={pData.prescriber}
                                                                placeholder="Prescriber"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        prescriber: v.target.value
                                                                    })

                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="editDetails" >Prescription Date</div>
                                                            <DatePicker
                                                                style={{ margin: 0 }}
                                                                placeholderText="mm/dd/yyyy"
                                                                selected={selectedDate}
                                                                // value={pData.prescription_date?pData.prescription_date:''}
                                                                className="form-control"
                                                                onChange={(date) => {
                                                                    setSelectedDate(date)
                                                                    // console.log(date)
                                                                    setPData({
                                                                        ...pData,
                                                                        prescription_date: date
                                                                        // formatDate(date)
                                                                    })
                                                                    // forceUpdate();
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <PrescriptionView /> */}

                                                    <Container className="mt-4" >
                                                        <Row>
                                                            <Col className="editDetails" ></Col>
                                                            <Col className="editDetails" >Sph</Col>
                                                            <Col className="editDetails" >Cyl</Col>
                                                            <Col className="editDetails" >Axis</Col>
                                                            <Col className="editDetails" >Prism</Col>
                                                            <Col className="editDetails" >TSC</Col>
                                                            <Col className="editDetails" >Dia</Col>
                                                        </Row>

                                                        <Row className="border-bottom border-secondary"  >
                                                            <Col className="editDetails" style={{ fontSize: 20 }} >OD</Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <input

                                                                    required
                                                                    value={pData.odsph}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    placeholder="Sph"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odsph: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <input

                                                                    required
                                                                    value={pData.odcyl}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    placeholder="Cyl"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odcyl: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <input
                                                                    // className=""
                                                                    required
                                                                    value={pData.odaxis}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    placeholder="Axis"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odaxis: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <input

                                                                    required
                                                                    value={pData.odprism}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    placeholder="Prism"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odprism: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <input
                                                                    required
                                                                    value={pData.odfi}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    placeholder="TSC"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odfi: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }}>
                                                                <input
                                                                    className="form-control form-control-user"
                                                                    required
                                                                    value={pData.odct}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    placeholder="Dia"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            odct: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>

                                                        <Row className="border-bottom border-secondary mt-2 " >
                                                            <Col className="editDetails" style={{ fontSize: 20 }} >OS</Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <input
                                                                    value={pData.ossph}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    required
                                                                    placeholder="Sph"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            ossph: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <input
                                                                    value={pData.oscyl}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    required
                                                                    placeholder="Cyl"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            oscyl: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <input
                                                                    value={pData.osaxis}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    required
                                                                    placeholder="Axis"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            osaxis: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <input
                                                                    value={pData.osprism}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    required
                                                                    placeholder="Prism"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            osprism: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <input
                                                                    value={pData.osfi}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    required
                                                                    placeholder="TSC"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            osfi: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                            <Col className="editDetails" style={{ fontFamily: 'PRe' }} >
                                                                <input
                                                                    value={pData.osct}
                                                                    className="col-sm-7 mt-2 form-control form-control-user"
                                                                    required
                                                                    placeholder="Dia"
                                                                    onChange={(v) => {
                                                                        setPData({
                                                                            ...pData,
                                                                            osct: v.target.value
                                                                        })
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Container >







                                                    <div class="row mt-4 mb-3 pl-4" style={{ justifyContent: 'center', }}>
                                                        <Form.Group className="col-sm-1 " id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.sv == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        sv: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="SV" className="check-box" />
                                                        </Form.Group>
                                                        {/* <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.protective_eyewear == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        protective_eyewear: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="PROTECTIVE EYEWER" className="check-box" />
                                                        </Form.Group> */}
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.contact_lenses_rx == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        contact_lenses_rx: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="CONTACT LENSES RX" className="check-box" />
                                                        </Form.Group>
                                                        {/* </div> */}
                                                        {/* <div class="row mt-2 mb-3 "> */}
                                                        {/* <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.bifocals == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        bifocals: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="BIFOCALS" className="check-box" />
                                                        </Form.Group>
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.transitions == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        transitions: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="TRANSITIONS" className="check-box" />
                                                        </Form.Group> */}
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.progressive == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        progressive: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="PROGRESSIVE" className="check-box" />
                                                        </Form.Group>
                                                    </div>

                                                    {/* <Button variant="primary" type="submit">
                                                        Save
                                                    </Button> */}
                                                    <input
                                                        type="submit"
                                                        id="add_customer"
                                                        className="btn btn-primary btn-user btn-block"
                                                        title="Save"
                                                        // onClick={() => addPresc()}
                                                        style={{ backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo' }}
                                                    />

                                                </form>



                                                {/* </form> */}
                                            </div>
                                        </div>
                                        {/* /.container-fluid */}
                                    </div>
                                    {/* End of Main Content */}
                                </div>
                                {/* End of Content Wrapper */}
                            </div>
                            {/* End of Page Wrapper */}
                            {/* Scroll to Top Button*/}
                            <a className="scroll-to-top rounded" href="#page-top">
                                <i className="fas fa-angle-up" />
                            </a>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPresciption



{/* <div class="row mb-3 ">
                                                        <div className="col-sm-6 mt-3">
                                                            <h3 style={{ color: 'grey' }} >OD</h3>
                                                            
                                                            <div className="editDetails mt-2 " >Sph</div>
                                                            <Form.Control
                                                                value={pData.odsph}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Sph"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        odsph: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Cyl</div>
                                                            <Form.Control
                                                                value={pData.odcyl}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Cyl"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        odcyl: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2 " >Axis</div>
                                                            <Form.Control
                                                                value={pData.odaxis}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Axis"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        odaxis: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Prism</div>
                                                            <Form.Control
                                                                value={pData.odprism}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Prism"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        odprism: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Fi</div>
                                                            <Form.Control
                                                                value={pData.odfi}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Fi"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        odfi: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Ct</div>
                                                            <Form.Control
                                                                value={pData.odct}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Ct"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        odct: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-sm-6 mt-3 ">
                                                            <h3 style={{ color: 'grey' }}>OS</h3>
                                                            <div className="editDetails mt-2" >Sph</div>
                                                            <Form.Control
                                                                value={pData.ossph}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Sph"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        ossph: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Cyl</div>
                                                            <Form.Control
                                                                value={pData.oscyl}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Cyl"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        oscyl: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Axis</div>
                                                            <Form.Control
                                                                value={pData.osaxis}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Axis"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        osaxis: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Prism</div>
                                                            <Form.Control
                                                                value={pData.osprism}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Prism"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        osprism: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Fi</div>
                                                            <Form.Control
                                                                value={pData.osfi}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Fi"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        osfi: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                            <div className="editDetails mt-2" >Ct</div>
                                                            <Form.Control
                                                                value={pData.osct}
                                                                className="col-sm-7 mt-2"
                                                                placeholder="Ct"
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        osct: v.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2 mb-3 ">

                                                        <Form.Group
                                                            className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.spect == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        spect: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="SPECTACLES" className="check-box" />
                                                        </Form.Group>

                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.dist == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        dist: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="DISTANCE" className="check-box" />
                                                        </Form.Group>
                                                        <Form.Group className="col-sm-2" id="formGridCheckbox">
                                                            <Form.Check
                                                                checked={pData.near == '1' ? true : false}
                                                                onChange={(v) => {
                                                                    setPData({
                                                                        ...pData,
                                                                        near: v.target.checked == true ? '1' : '0'
                                                                    })
                                                                }}
                                                                type="checkbox" label="NEAR" className="check-box" />
                                                        </Form.Group>
                                                    </div> */}
